import gql from 'graphql-tag';

export default gql`
  query GetAllEvents($where: EventWhereInput) {
    events(orderBy: updatedAt_DESC, where: $where) {
      createdAt
      id
      updatedAt
      name
      type
      host
      location
      startDate
      endDate
      accessStartDate
      accessEndDate
      description
      links
      status
    }
  }
`;



// WEBPACK FOOTER //
// ./src/graphql/queries/GetAllEvents.ts